(function () {
  const CARD_INNER_SELECTOR = '.spf-product-card__inner';
  const IMAGE_WRAPPER_SELECTOR = '.spf-product-card__image-wrapper';
  const NEXT_BUTTON_SELECTOR = '.spf-product-card__images-navigation .next';
  const PREV_BUTTON_SELECTOR = '.spf-product-card__images-navigation .prev';

  let touchStartX = null;
  let touchStartY = null;
  let activeWrapper = null;
  let isSwipingHorizontally = false;

  const MIN_SWIPE_DISTANCE = 40;   // финальная длина свайпа для переключения
  const DETECT_THRESHOLD = 10;     // с какого момента начинаем считать жест свайпом

  function isTouchDevice() {
    return (
      (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ||
      'ontouchstart' in window
    );
  }

  // TOUCHSTART — фиксируем начальную точку
  document.addEventListener(
    'touchstart',
    function (e) {
      if (!isTouchDevice()) return;

      const wrapper = e.target.closest(IMAGE_WRAPPER_SELECTOR);
      if (!wrapper) return;

      const touch = e.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      activeWrapper = wrapper;
      isSwipingHorizontally = false;
    },
    { passive: true } // здесь можно оставить passive, мы ничего не предотвращаем
  );

  // TOUCHMOVE — решаем, горизонтальный это жест или вертикальный
  document.addEventListener(
    'touchmove',
    function (e) {
      if (!isTouchDevice()) return;
      if (!activeWrapper || touchStartX === null || touchStartY === null) return;

      const touch = e.touches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      // Если ещё не решили, что это горизонтальный свайп — проверяем
      if (!isSwipingHorizontally) {
        if (Math.abs(deltaX) > DETECT_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
          // Явно горизонтальный жест → считаем, что это свайп по картинке
          isSwipingHorizontally = true;
        } else {
          // Больше вертикали → даём странице нормально скроллиться
          return;
        }
      }

      // Если уже определили, что жест горизонтальный — блокируем вертикальный скролл страницы
      if (isSwipingHorizontally) {
        e.preventDefault();
      }
    },
    { passive: false } // ОБЯЗАТЕЛЬНО, иначе preventDefault не сработает
  );

  // TOUCHEND — считаем свайп и переключаем картинку
  document.addEventListener(
    'touchend',
    function (e) {
      if (!isTouchDevice()) return;
      if (!activeWrapper || touchStartX === null || touchStartY === null) {
        // сброс на всякий
        touchStartX = touchStartY = null;
        activeWrapper = null;
        isSwipingHorizontally = false;
        return;
      }

      const touch = e.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;

      const card = activeWrapper.closest(CARD_INNER_SELECTOR);

      // сбрасываем состояние
      touchStartX = touchStartY = null;
      activeWrapper = null;

      if (!card || !isSwipingHorizontally) {
        isSwipingHorizontally = false;
        return;
      }

      isSwipingHorizontally = false;

      // короткий жест — не переключаем
      if (Math.abs(deltaX) < MIN_SWIPE_DISTANCE) return;

      if (deltaX < 0) {
        const nextBtn = card.querySelector(NEXT_BUTTON_SELECTOR);
        if (nextBtn) nextBtn.click();
      } else {
        const prevBtn = card.querySelector(PREV_BUTTON_SELECTOR);
        if (prevBtn) prevBtn.click();
      }
    },
    { passive: false } // пусть тоже может при необходимости отменять
  );
})();